import {infoComponent} from "./info.component";

export const infoModule = angular
	.module("info", [])
	.component("info", infoComponent);


// WEBPACK FOOTER //
// ./sources/utility/info/info.js